import Swal from 'sweetalert2';
import { Color } from '../../assets/colors';
import * as actionTypes from '../action-types';
import { toaster } from '../../services/toast-service';
import { getAPI, postAPI } from '../../utils/api-function';
import { call, put, takeLeading } from 'redux-saga/effects';
import { create_consultancy, get_breaking_news, get_category, get_daily_darshan, get_live_video, get_news_by_categoryId, get_news_category, get_podcast_by_sub_category, get_sub_category, get_video_by_sub_category } from '../../utils/api-routes';


function* getCategory() {
    try {
        const { data } = yield getAPI({ url: get_category });
        console.log("Get Category Saga Response :::", data);
        yield put({ type: actionTypes.SET_CATEGORY, payload: data?.results || {} });

    } catch (error) {
        console.log("Get Category Saga Error :::", error);
        yield put({ type: actionTypes.SET_CATEGORY, payload: {} });
    }
}

function* getSubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);
        const { data } = yield postAPI({ url: get_sub_category, payload });
        console.log("Get SubCategory Saga Response :::", data);
        yield put({ type: actionTypes.SET_SUB_CATEGORY, payload: data?.results || [] });
    } catch (error) {
        console.log("Get SubCategory Saga Error :::", error);
        yield put({ type: actionTypes.SET_SUB_CATEGORY, payload: [] });
    }
}

function* getDataBySubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);
        const { data } = yield postAPI({ url: get_video_by_sub_category, payload });
        console.log("Get Data By SubCategory Saga Response :::", data);
        yield put({ type: actionTypes.SET_DATA_BY_SUB_CATEGORY, payload: data?.results || [] });
    } catch (error) {
        console.log("Get Data By SubCategory Saga Error :::", error);
        yield put({ type: actionTypes.SET_DATA_BY_SUB_CATEGORY, payload: [] });
    }
}

function* getPodcastBySubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);
        const { data } = yield postAPI({ url: get_podcast_by_sub_category, payload });
        console.log("Get Podcast By SubCategory Saga Response :::", data);
        yield put({ type: actionTypes.SET_PODCAST_BY_SUB_CATEGORY, payload: data?.results || [] });
    } catch (error) {
        console.log("Get Podcast By SubCategory Saga Error :::", error);
        yield put({ type: actionTypes.SET_PODCAST_BY_SUB_CATEGORY, payload: [] });
    }
}

//! News
function* getBreakingNews() {
    try {
        const { data } = yield getAPI(get_breaking_news);
        console.log("Breaking News Saga Response :::", data);
        yield put({ type: actionTypes.SET_BREAKING_NEWS, payload: data?.result || [] });
    } catch (error) {
        console.log("Breaking News Saga Error :::", error);
        yield put({ type: actionTypes.SET_BREAKING_NEWS, payload: [] });
    }
}

function* getNewsCategory() {
    try {
        const { data } = yield getAPI({ url: get_news_category });
        console.log("News Category Saga Response :::", data);
        yield put({ type: actionTypes.SET_NEWS_CATEGORY, payload: data?.results || [] });
    } catch (error) {
        console.log("News Category Saga Error :::", error);
        yield put({ type: actionTypes.SET_NEWS_CATEGORY, payload: [] });
    }
}

function* getNewsByCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);
        const { data } = yield postAPI({ url: get_news_by_categoryId, payload });
        console.log("News By Category Saga Response :::", data);
        yield put({ type: actionTypes.SET_NEWS_BY_CATEGORY, payload: data?.results || [] });
    } catch (error) {
        console.log("News By Category Saga Error :::", error);
        yield put({ type: actionTypes.SET_NEWS_BY_CATEGORY, payload: [] });
    }
}

//! Live
function* getLiveVideo() {
    try {
        const { data } = yield getAPI({ url: get_live_video });
        console.log("Live Video Saga Response :::", data);
        yield put({ type: actionTypes.SET_LIVE_VIDEO, payload: data?.data || [] });
    } catch (error) {
        console.log("Live Video Saga Error :::", error);
        yield put({ type: actionTypes.SET_LIVE_VIDEO, payload: [] });
    }
}

//! Daily Darshan
function* getDailyDarshan() {
    try {
        const { data } = yield getAPI({ url: get_daily_darshan });
        console.log("Get Daily Darshan Saga Response :::", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_DAILY_DARSHAN, payload: data.data });
        } else {
            yield put({ type: actionTypes.SET_DAILY_DARSHAN, payload: [] });
        }
    } catch (error) {
        console.log("Get Daily Darshan Saga Error :::", error);
        yield put({ type: actionTypes.SET_DAILY_DARSHAN, payload: [] });
    }
}

//! Consultancy
function* createConsultancy(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to request a consultancy?", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: Color.red, confirmButtonText: "Yes", });

        if (result.isConfirmed) {
            const { data } = yield postAPI({ url: create_consultancy, payload: payload?.data });
            console.log("Create Consultancy Saga Response :::", data);

            if (data?.success) {
                Swal.fire({ icon: "success", text: data.message || data.messsage, showConfirmButton: false, timer: 2000 });
                yield call(payload?.onComplete);
            } else {
                Swal.fire({ icon: "info", text: data.message || data.messsage, showConfirmButton: false, timer: 20000 });
            }
        }
    } catch (error) {
        console.log("Create Consultancy Saga Error :::", error);
        Swal.fire({ icon: "error", text: error?.response?.data?.message, showConfirmButton: false, timer: 20000 });
    }
}

export default function* authSaga() {
    yield takeLeading(actionTypes.GET_CATEGORY, getCategory);
    yield takeLeading(actionTypes.GET_SUB_CATEGORY, getSubCategory);
    yield takeLeading(actionTypes.GET_DATA_BY_SUB_CATEGORY, getDataBySubCategory);
    yield takeLeading(actionTypes.GET_PODCAST_BY_SUB_CATEGORY, getPodcastBySubCategory);

    //! News
    yield takeLeading(actionTypes.GET_BREAKING_NEWS, getBreakingNews);
    yield takeLeading(actionTypes.GET_NEWS_CATEGORY, getNewsCategory);
    yield takeLeading(actionTypes.GET_NEWS_BY_CATEGORY, getNewsByCategory);

    //! Live
    yield takeLeading(actionTypes.GET_LIVE_VIDEO, getLiveVideo);

    //! Daily Darshan
    yield takeLeading(actionTypes.GET_DAILY_DARSHAN, getDailyDarshan);

    //! Consultancy
    yield takeLeading(actionTypes.CREATE_CONSULTANCY, createConsultancy);
};